import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { PhoneFill } from "antd-mobile-icons";
import instance from "../../../util/axios";
const MailListFrom = styled.div`
  .body {
    // width:100%;
    // padding:10px;
  }
  .title {
    position: fixed;
    height: 100px;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 100%;
    background-color: #ffffff;
  }
  .ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .li {
    width: 100%;
    height: 50px;
    border: 1px solid #797979;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: 5px;
    margin-bottom: 10px;
  }
  .pdd {
    padding: 0 10px 0 10px;
  }
  .size {
    font-size: 22px;
  }
  .margin {
    margin-top: 10px;
  }
`;
interface Array1 {
  uuid: string;
  name: string;
  telephone: number;
}
export default function MailList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const [keyword, setKeyword] = useState<string>();
  const [staffList, setstaffList] = useState<Array1[]>([]);
  const history = useHistory();
  useEffect(() => {
    instance
      .get(`/oa/humanResources/ValidationChecks/getStaffListCommunication`)
      .then((resp) => {
        console.log(resp);
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setstaffList(resp.data.Data.data);
          // console.log(staffList)
        }
      });
  }, []);
  const searchBarChange = useCallback((keyword) => {
    instance
      .get(
        `/oa/humanResources/ValidationChecks/getStaffListCommunication?mobileParam=` +
          keyword
      )
      .then((resp) => {
        console.log(resp);
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setstaffList(resp.data.Data.data);
          // console.log(staffList)
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance
      .get(`/oa/humanResources/ValidationChecks/getStaffListCommunication`)
      .then((resp) => {
        if (resp.data.Status === "1") {
          setstaffList(resp.data.Data.data);
        }
      });
  }, []);

  return (
    <>
      <MailListFrom>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/index`);
                }}
              />
            }
          >
            通讯录
          </NavBar>
          <SearchBar
            value={keyword}
            onChange={(value) => setKeyword(value)}
            placeholder="请输入内容"
            className="margin"
            onSubmit={() => {
              searchBarChange(keyword);
            }}
            onCancel={() => {
              noSearch();
            }}
            // onChange={searchBarChange}
          />
          <WhiteSpace />
          <div className="pdd">
            <ul className="ul">
              {staffList.map((item) => (
                <li
                  className="li"
                  onClick={() => {
                    window.location.href =
                      "/hr/maildetailslist?uuid=" + item.uuid;
                  }}
                >
                  <span>{item.name}</span>
                  <span>{item.telephone}</span>
                  <a href="{item.telephone}">
                    <PhoneFill className="size" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {staffList.length === 0 && (
            <div style={{ textAlign: "center", marginTop: 10 }}>
              <span>暂无更多数据</span>
            </div>
          )}
        </div>
      </MailListFrom>
    </>
  );
}
